import { ReactNode } from "react";
import styled from "styled-components";

export const Badge = styled.span`
	background: var(--nte-graa-lys);
	border-radius: var(--border-radius);
	padding: 0.1em 0.5em;
	white-space: nowrap;
`;

export const SuccessBadge = styled(Badge)`
	background: var(--nte-groenn);
	color: var(--white);
`;

export const WarningBadge = styled(Badge)`
	background: #ffcc00;
`;

export const DangerBadge = styled(Badge)`
	background: var(--nte-korall-morkest);
	color: var(--white);
`;

export function ActiveBadge({ active }: { active: boolean }) {
	return active ? <SuccessBadge>Aktiv</SuccessBadge> : <DangerBadge>Inaktiv</DangerBadge>;
}

export function TrafficLightBadge({ green, red, children }: Readonly<{ green?: boolean; red?: boolean; children: ReactNode }>) {
	if (green && !red) return <SuccessBadge>{children}</SuccessBadge>;
	if (red && !green) return <DangerBadge>{children}</DangerBadge>;

	return <WarningBadge>{children}</WarningBadge>;
}
